import {Layout, message } from "antd";
import {Component } from "react";
import Header from "./header";
import Footer from "./footer";
import CRouter from "../routes";
import SideNav from "./sidenav";
import storage from "../utils/storage";
import { configs } from "../config/config";
import { route } from "../routes/routes";
import { getGroup } from "../model/group/requests";
const {Content,Sider} = Layout;
class Main extends Component {
    constructor(props){
        super(props)
        this.state = {
            role:"default"
        }
    }

    // load the current roles when user login , if the user not login the  system
    // return to login page
    componentDidMount(){
        if (!storage.check(configs.cache.tokenKey)){
            this.props.history.push(route.default.login)
        }
        let role = "";
        // 加载个人用用户的role
        let user = storage.get(configs.cache.tokenKey)
        if(user.group_id){
            getGroup({id:user.group_id}).then(res=>{
                if(res.data.code === 200){
                    let groupInfo = res.data.data
                    let roleList = groupInfo.roles
                    if(roleList.length >0){
                        for(let i = 0 ;i < roleList.length;i++){
                            role = roleList[i].menu
                        }
                    }
                    this.setState({
                        role:role
                    })
                }
            }).catch(err=>{
                message.error(err)
            })
        }


    }

    render(){
        const {role} = this.state
        return(
            <>
                <Layout >
                    <Header />
                    <Layout>
                        <Sider 
                            style={{ width: 200,
                                height: '100vh',
                            }}
                            theme='light'  >
                            <SideNav
                                roles ={role}
                            />
                        </Sider>
                        <Layout  >
                            <Content
                                style = {{
                                    padding: 24,
                                    margin: 0,
                                    overflow: 'initial',
                                }}
                                >
                                <CRouter {...this.props }/> 
                            </Content>
                        </Layout>
                    </Layout>
                    <Footer />
            </Layout>
        
            </>

        )
    }
}

export default Main;